import { Grid } from "@mui/material";
import React, {useState, useEffect} from "react";
import PropTypes from 'prop-types'
import ViewOffers from "./ViewOffers";
import ErrorPopUp from "../../../components/Pop_ups/ErrorPopUp";
import {isObjectEmpty} from '../../../util/generalHelp'
import OfferForm from "./NewOfferForm"
import { getOfferLetters, getOfferLetter } from "../../../util/offerLettersHelp";

/**
 * Page responsible for handling Offer Letters
 * @component
 * @category Pages
 * @subcategory Admin
 */
//function ManageOffers({authorities, clients, states, venues, contacts, recruiters, accountManagers, }){
function ManageOffers(props){    
    const unvoidable = ['voided', 'deleted', 'completed']

    const [hasLoaded, setHasLoaded] = useState(false)
    const [loadingOffers, setLoadingOffers] = useState(false)
    const [offerLetters, setOfferLetters] = useState([])
    const [pagination, setPagination] = useState({})
    const [errorObj, setErrorObj]  = useState({})

    const handleError = (errorObject=undefined) => {
        try{
            setErrorObj({errorTitle: errorObject.errorTitle, errorContent:errorObject.errorContent})
        }catch{
            setErrorObj({errorTitile: undefined, errorContent:undefined})
        }
    }

    const retrieveOfferLetters = (page=1, limit=25, abortCont=undefined) => {
        setLoadingOffers(true)
        getOfferLetters(page, limit, abortCont, (json) => {
            if(json){
                setOfferLetters(json.envelopes)
                setPagination(json)
                setHasLoaded(true)
            }else{
                handleError()
            }
            setLoadingOffers(false)
        })
        
    }

    useEffect(()=>{
        
           
        let abortCont = new AbortController()
        if(!hasLoaded){
            retrieveOfferLetters(1, 25, abortCont)
        }
        return () => abortCont.abort()
    }, [])

    const updateOffers = () => {
        retrieveOfferLetters()
    }

    // previous offer letter ({offer, form, loadCount}) that the offer form is filled with
    const [loadedOffer, setLoadedOffer] = useState(null)
    const [loadingOfferId, setLoadingOfferId] = useState(null)

    const loadOfferLetter = (offer) => {
        setLoadingOfferId(offer.id)
        getOfferLetter(offer.id, (json) => {
            if(json){
                // loadCount changes on every load so loading the same offer again still refills the form
                setLoadedOffer(prev => ({offer: json.offer, form: json.form, loadCount: (prev?.loadCount ?? 0) + 1}))
                window.scrollTo({top: 0, behavior: 'smooth'})
                if(!json.form){
                    handleError({errorTitle: "Offer Partially Loaded", errorContent: "This offer letter was drafted before the full form was saved, "
                        + "so only the candidate's name and email, the approver and the contact were filled in. Please fill in the rest of the form."})
                }
            }else{
                handleError({errorTitle: "Uh Oh!", errorContent: "Something went wrong when trying to load the offer letter, please try again"})
            }
            setLoadingOfferId(null)
        })
    }
    //ok, clearly offerform is meant to "be passed" these fields as seen here
    //new one maybe isn't handling it the way the old one was
    //should these fields be kept separate/specific? or should they be generalized in some way?
    //easiest would be to just add these into the function...definition thing, right
    //as was in original offerform
    //unsure if that would work though
    //how are masterservices etc passed what they use? is it all just "props"?
    //try going closer to that, then try more specific, and if neither work, idk
    return(
    <Grid container sx={{justifyContent:'center',alignItems:'center'}}>
        <ErrorPopUp errorContent={errorObj.errorContent} errorTitle={errorObj.errorTitle} open={!isObjectEmpty(errorObj)}
            onClose={(e) => {e.preventDefault(); setErrorObj({})}}/>
        <Grid container sx={{justifyContent:'center',alignItems:'center', height:'30%'}}>
            <OfferForm authorities={props.authorities} clients={props.clients}
            states={props.states} venues={props.venues} recruiters={props.recruiters} accountManagers={props.accountManagers} signatories={props.signatories}
            contacts={props.contacts} onComplete={retrieveOfferLetters}  onError={handleError} loadedOffer={loadedOffer}/>
        </Grid>
        <Grid container sx={{justifyContent:'center',alignItems:'center', height:'65%', width:'100%'}}>
            <ViewOffers offers={offerLetters} onError={handleError} updateOffers={updateOffers} unvoidableStatuses={unvoidable}
            pagination={pagination} onPageinate={retrieveOfferLetters} loading={loadingOffers}
            onLoadOffer={loadOfferLetter} loadingOfferId={loadingOfferId}/>
        </Grid>
    </Grid>
    )
}

ManageOffers.propTypes={
    /**
     * profile of currently signed in user
     */
    profile: PropTypes.object.isRequired
}

export default ManageOffers